module.exports = __webpack_public_path__ + "static/media/arrow-down-k.e2528d48.svg";